/** Allocation positions, rather than the printed numeric values, define adjacency. */
export function isNonAdjacentIdentifierOrder(
  orderIndex: number,
  assignedOrderIndexes: readonly number[]
) {
  return assignedOrderIndexes.every(assigned => Math.abs(assigned - orderIndex) > 1)
}
